
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.5 6v.031A4 4 0 1118 14H5a5 5 0 11.818-9.933A6 6 0 0117.5 6zm-7.325 5.5l.806-3.143a16.032 16.032 0 00.151-.693l.08-.408c.026-.129.041-.232.047-.31.005.078.02.181.046.31.025.13.053.266.084.412l.084.403c.025.124.046.216.063.278l.815 3.151h1.446l1.529-6h-1.252l-.765 3.277a59.55 59.55 0 01-.105.492 14.112 14.112 0 00-.189 1.08c-.017-.135-.042-.3-.075-.496a20.918 20.918 0 00-.105-.567 6.346 6.346 0 00-.097-.425L11.864 5.5h-1.202l-.896 3.445c-.022.09-.047.204-.074.34-.037.183-.072.37-.105.564-.034.193-.06.36-.076.5-.017-.135-.042-.3-.076-.496-.033-.196-.07-.392-.109-.588a8.922 8.922 0 00-.11-.488L8.453 5.5H7.2l1.53 6h1.445z"}})])
          )
        }
      }
    